/**
 * Spec backend-followups — typed API client for the per-tenant budget endpoint.
 *
 *   GET /api/v1/tenants/:tenantId/budget → { data: TenantBudget }
 *
 * The endpoint reports monthly spend vs cap for the calling user's tenant
 * (server-side ACL enforces caller is a member of `tenantId`). Same envelope
 * shape as the rest of the v1 API — thin wrapper over `apiGet` so the 401
 * redirect handling stays consistent.
 */
import { apiGet } from '../lib/api.js';

export interface TenantBudget {
  tenant_id: string;
  monthly_cost_cap_usd: number;
  monthly_spend_usd: number;
  remaining_usd: number;
  percentage_used: number;
  /**
   * Spec 161 — month-to-date spend per cost stream (keys: queries /
   * page_evaluations / fan_out / llms_txt). Values sum to monthly_spend_usd.
   * Optional for resilience against older API responses.
   */
  by_stream?: Record<string, number>;
  /** YYYY-MM */
  period: string;
}

export async function getTenantBudget(tenantId: string): Promise<TenantBudget> {
  const res = await apiGet<{ data: TenantBudget }>(
    `/api/v1/tenants/${encodeURIComponent(tenantId)}/budget`,
  );
  return res.data;
}
